import { ROOM_TYPE } from "../../../constants/discussion";
import chat from '@/mixins/chat';
import SectionTitle from '../../../components/SectionTitle/SectionTitle.vue';
import { format } from "path";
import moment from "moment";

export default {
    props: ['info', 'isActive','name', 'isUnreadMessage'],
    mixins: [chat],
    components: {
        SectionTitle,
      },    computed: {
        isTeam() {
            return this.info.type == ROOM_TYPE.TEAM;
        },
        isAgency() {
            return this.info.type == ROOM_TYPE.AGENCY
        },
        groupInfo() {
            return {
                ...this.info,
                lastTime: this.info.lastTime ? this.info.lastTime : "",
                lastMess: this.info.lastMsg? this.info.lastMsg.text : this.$t('no-data')
            }
        },
    },
    methods: {
        clickItem(item) {
            if (item) {
                this.$emit('click', item);
            }
        },
        getDescription(description) {
        if(description== this.$t('adv-mon-equipe-label')) {
            return this.$t('adv-mon-equipe-replace-label')
        }
        return description;
        },
    }
}